import { IItem } from "../types";

export const internships: IItem[] = [
  {
    description: "shipped audit logs and built some really useful hooks at",
    company: "Cockroach Labs",
    link: "https://www.cockroachlabs.com/",
  },
  {
    description: "built crypto payment systems at",
    company: "ETHGlobal",
    link: "https://www.ethglobal.com/",
  },
  {
    description: "shipped 1-on-1 tutoring features at",
    company: "Outschool",
    link: "https://www.outschool.com/",
  },
  {
    description: "optimized data queries and analytics at",
    company: "Kiavi",
    link: "https://www.kiavi.com/",
  },
  {
    description: "built developer tools to speed up mobile development at",
    company: "Wealthsimple",
    link: "https://www.wealthsimple.com/",
  },
  {
    description: "shipped growth features at",
    company: "Faire",
    link: "https://www.faire.com/",
  },
];
